// ============================================
// SCRIPT PARA GARANTIZAR FILAS COMPLETAS
// Versión 3.0 - NUNCA ELIMINA, SOLO OCULTA
// ============================================

(function() {
  'use strict';
  
  console.log('🔄 Iniciando sistema de filas completas v3.0...');
  
  /**
   * Detecta si estamos en la última página de la colección
   */
  function esUltimaPagina() {
    const paginacion = document.querySelector('.pagination');
    if (!paginacion) {
      console.log('📄 No hay paginación - Asumiendo página única');
      return true;
    }
    
    // Buscar el botón "siguiente" o "next"
    const botonSiguiente = paginacion.querySelector('[aria-label*="siguiente"]') ||
                           paginacion.querySelector('[aria-label*="next"]') ||
                           paginacion.querySelector('.pagination__item--next') ||
                           paginacion.querySelector('[rel="next"]') ||
                           paginacion.querySelector('a[href*="page="]');
    
    const esUltima = !botonSiguiente || botonSiguiente.classList.contains('disabled');
    console.log(`📄 ¿Es última página?: ${esUltima ? 'SÍ' : 'NO'}`);
    
    return esUltima;
  }
  
  /**
   * Función principal para garantizar filas completas
   */
  function garantizarFilasCompletas() {
    console.log('\n========================================');
    console.log('🔍 VERIFICANDO FILAS COMPLETAS');
    console.log('========================================');
    
    // Detectar si estamos en mobile o desktop
    const isMobile = window.innerWidth < 750;
    const productosPorFila = isMobile ? 2 : 4;
    
    console.log(`📱 Modo: ${isMobile ? 'MÓVIL' : 'DESKTOP'}`);
    console.log(`📊 Productos por fila: ${productosPorFila}`);
    
    // Obtener el grid de productos
    const productGrid = document.querySelector('#product-grid.product-grid-custom, #product-grid, .product-grid-custom');
    
    if (!productGrid) {
      console.log('❌ Grid de productos no encontrado');
      return;
    }
    
    console.log('✅ Grid encontrado:', productGrid.id);
    
    // Obtener TODOS los <li> del grid
    const todasLasTarjetas = Array.from(productGrid.querySelectorAll(':scope > li'));
    
    console.log(`📦 Total de <li> en el DOM: ${todasLasTarjetas.length}`);
    
    if (todasLasTarjetas.length === 0) {
      console.log('⚠️ No hay productos en el grid');
      return;
    }
    
    // PRIMERO: Restaurar TODAS las tarjetas (quitar display:none que hayamos puesto antes)
    todasLasTarjetas.forEach(tarjeta => {
      if (tarjeta.hasAttribute('data-hidden-by-filas-completas')) {
        tarjeta.style.removeProperty('display');
        tarjeta.removeAttribute('data-hidden-by-filas-completas');
      }
    });
    
    // Ahora filtrar las que están NATURALMENTE visibles (no ocultas por otros scripts/CSS)
    const tarjetasNaturalmenteVisibles = todasLasTarjetas.filter(tarjeta => {
      const estilos = window.getComputedStyle(tarjeta);
      // Consideramos visible si no tiene display:none, visibility:hidden, o opacity:0
      const esVisible = estilos.display !== 'none' && 
                       estilos.visibility !== 'hidden' && 
                       parseFloat(estilos.opacity) > 0;
      return esVisible;
    });
    
    console.log(`👁️ Tarjetas naturalmente visibles: ${tarjetasNaturalmenteVisibles.length}`);
    
    const totalTarjetas = tarjetasNaturalmenteVisibles.length;
    const tarjetasCompletas = Math.floor(totalTarjetas / productosPorFila) * productosPorFila;
    const tarjetasSobrantes = totalTarjetas - tarjetasCompletas;
    
    console.log(`✅ Tarjetas que completan filas: ${tarjetasCompletas}`);
    console.log(`⚠️ Tarjetas sobrantes: ${tarjetasSobrantes}`);
    
    // Si no hay tarjetas sobrantes, no hacer nada
    if (tarjetasSobrantes === 0) {
      console.log('✅ Todas las filas están completas - No se requiere acción');
      console.log('========================================\n');
      return;
    }
    
    // VERIFICAR SI ES LA ÚLTIMA PÁGINA
    const ultimaPagina = esUltimaPagina();
    
    // SI ES LA ÚLTIMA PÁGINA, NO OCULTAR NADA
    if (ultimaPagina) {
      console.log('✅ ÚLTIMA PÁGINA detectada - Mostrando TODOS los productos');
      console.log('========================================\n');
      return;
    }
    
    // Si NO es la última página, ocultar las tarjetas sobrantes AL FINAL
    console.log(`🔧 Página intermedia - Ocultando ${tarjetasSobrantes} tarjetas sobrantes...`);
    
    // Ocultar solo las últimas N tarjetas sobrantes
    for (let i = tarjetasCompletas; i < totalTarjetas; i++) {
      const tarjeta = tarjetasNaturalmenteVisibles[i];
      
      // IMPORTANTE: Usar setProperty con !important para asegurar que se aplique
      tarjeta.style.setProperty('display', 'none', 'important');
      tarjeta.setAttribute('data-hidden-by-filas-completas', 'true');
      
      console.log(`  - Ocultando producto ${i + 1}`);
    }
    
    console.log('✅ Filas completas garantizadas');
    console.log('========================================\n');
  }
  
  /**
   * Función para restaurar TODAS las tarjetas ocultas por este script
   */
  function restaurarTodasLasTarjetas() {
    console.log('🔄 Restaurando todas las tarjetas...');
    
    const tarjetasOcultas = document.querySelectorAll('[data-hidden-by-filas-completas="true"]');
    
    console.log(`📦 Tarjetas a restaurar: ${tarjetasOcultas.length}`);
    
    tarjetasOcultas.forEach((tarjeta, index) => {
      tarjeta.style.removeProperty('display');
      tarjeta.removeAttribute('data-hidden-by-filas-completas');
      console.log(`  ✅ Restaurada tarjeta ${index + 1}`);
    });
    
    console.log('✅ Todas las tarjetas restauradas');
  }
  
  /**
   * Ejecutar con debounce
   */
  let timeoutId;
  function ejecutarConDebounce(delay = 100) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      garantizarFilasCompletas();
    }, delay);
  }
  
  // ============================================
  // EJECUCIÓN INICIAL
  // ============================================
  
  console.log('⏳ Esperando a que la página cargue...');
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('✅ DOM cargado');
      ejecutarConDebounce(100);
    });
  } else {
    console.log('✅ DOM ya estaba cargado');
    ejecutarConDebounce(100);
  }
  
  // Ejecutar con delays progresivos para asegurar que cargó todo
  setTimeout(() => ejecutarConDebounce(50), 300);
  setTimeout(() => ejecutarConDebounce(50), 600);
  setTimeout(() => ejecutarConDebounce(50), 1000);
  setTimeout(() => ejecutarConDebounce(50), 2000);
  
  // ============================================
  // OBSERVADORES
  // ============================================
  
  // Observar cambios en el grid
  setTimeout(() => {
    const productGrid = document.querySelector('#product-grid.product-grid-custom, #product-grid');
    if (productGrid) {
      console.log('👀 Observador del grid activado');
      
      const observer = new MutationObserver((mutations) => {
        // Solo reaccionar a cambios significativos
        const cambioSignificativo = mutations.some(mutation => 
          mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
        );
        
        if (cambioSignificativo) {
          console.log('🔄 Cambios detectados en el grid');
          ejecutarConDebounce(200);
        }
      });
      
      observer.observe(productGrid, {
        childList: true,
        subtree: false
      });
    }
  }, 1000);
  
  // ============================================
  // EVENT LISTENERS
  // ============================================
  
  // Resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      console.log('📐 Resize detectado');
      ejecutarConDebounce(250);
    }, 250);
  });
  
  // Navegación
  window.addEventListener('popstate', () => {
    console.log('◀️ Navegación (popstate)');
    setTimeout(() => ejecutarConDebounce(300), 300);
  });
  
  // Monitorear cambios de URL
  let lastUrl = window.location.href;
  setInterval(() => {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      console.log('🔗 URL cambió:', currentUrl);
      setTimeout(() => ejecutarConDebounce(300), 300);
      setTimeout(() => ejecutarConDebounce(300), 1000);
    }
  }, 500);
  
  // Clicks en paginación
  document.addEventListener('click', (e) => {
    const esPaginacion = e.target.closest('.pagination');
    if (esPaginacion) {
      console.log('📄 Click en paginación');
      setTimeout(() => ejecutarConDebounce(500), 500);
      setTimeout(() => ejecutarConDebounce(500), 1500);
    }
  });
  
  // ============================================
  // API GLOBAL
  // ============================================
  
  window.FilasCompletas = {
    version: '3.0',
    verificar: () => {
      console.log('🔄 Verificación forzada');
      garantizarFilasCompletas();
    },
    restaurar: restaurarTodasLasTarjetas,
    esUltimaPagina: esUltimaPagina,
    info: () => {
      const productGrid = document.querySelector('#product-grid.product-grid-custom, #product-grid');
      if (!productGrid) {
        console.log('❌ Grid no encontrado');
        return null;
      }
      
      const todasLasTarjetas = Array.from(productGrid.querySelectorAll(':scope > li'));
      const tarjetasOcultas = document.querySelectorAll('[data-hidden-by-filas-completas="true"]');
      const tarjetasVisibles = todasLasTarjetas.filter(t => {
        const s = window.getComputedStyle(t);
        return s.display !== 'none';
      });
      const ultimaPagina = esUltimaPagina();
      
      const info = {
        version: '3.0',
        total: todasLasTarjetas.length,
        visibles: tarjetasVisibles.length,
        ocultasPorScript: tarjetasOcultas.length,
        ultimaPagina: ultimaPagina
      };
      
      console.log('📊 INFORMACIÓN DEL SISTEMA:');
      console.log(info);
      
      return info;
    }
  };
  
  console.log('✅ Sistema de filas completas v3.0 inicializado');
  console.log('💡 Comandos disponibles:');
  console.log('   FilasCompletas.info() - Ver estadísticas');
  console.log('   FilasCompletas.verificar() - Forzar verificación');
  console.log('   FilasCompletas.restaurar() - Mostrar todo');
  console.log('   FilasCompletas.esUltimaPagina() - Verificar si es última página');
  
})();